import React from 'react';
import {Link} from 'react-router-dom';

const PageTitle = ({activeName, motherName})=>{
	return(
		<>
			<div className="container">
				<div className="dez-bnr-inr-entry">
					<h1 className="text-white" yle={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '20px' }}>{activeName}</h1>
					{false &&<div className="breadcrumb-row">
						<ul className="list-inline">
							<li><Link to={"#"}>{motherName}</Link></li>
							<li>{activeName}</li>
						</ul>
					</div>}
				</div>
			</div>
		</>
	)
}
export default PageTitle;